import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col, Dropdown, Image, Modal } from "react-bootstrap";
import { Tab, Nav } from "react-bootstrap";
import { toast } from "react-toastify";

import MobileMenu from "./common/MobileMenu";
import { Styles } from "./styles/headerTwo.js";
import { GetApi, PostApi } from "../services/CommonService2.js";
import { TabStyles } from "../pages/faq/styles/tab.js";
import { Button } from "react-bootstrap";
// import { Dropdown } from 'react-bootstrap';
import LoginModal from "./LoginModal.js";
import Register from "../pages/account/Register.js";
import Student from "./offlineEnroll/Student.js";
import Fresher from "./offlineEnroll/Fresher.js";
import Employee from "./offlineEnroll/Employee.js";
import Notifications from "./Notifications.js";
import navimg from "./../politicalimgeas/backgrounds/background1.jpg";
// import Dropdown from 'react-bootstrap/Dropdown';
// import DropdownButton from 'react-bootstrap/DropdownButton';

export default function HeaderTwo() {
  const [logo, setLogo] = useState([]);
  const [headerTabs, setHeaderTabs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [user, setUser] = useState("");
  const [userMobile, setUserMobile] = useState("");

  const [toggleUser, setToggleUser] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [userProfile, setUserProfile] = useState("");
  const [courses, setCourses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [notificationmodal, setNotificationmodal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [tenantdata, setTenantData] = useState({});
  const [loginModal, setLoginModal] = useState(false);
  const [modalUp, setModalUp] = useState(false);
  const [selectedState, setSelectedState] = useState([]);
  const [couponPurchase, setCouponPurchase] = useState(false);
  const [tenantId, setTenantId] = useState("");
  const [userData, setUserData] = useState("");

  const [offlineModalShow, setOfflineModalShow] = useState(false);
  const [isOpenFlag, setIsOpenFlag] = useState(false);

  const [eduData, setEduData] = useState([]);
  const [eduTypes, setEduTypes] = useState([]);
  const [tenantData, settenantData] = useState("");
  const history = useHistory();
  const [districts, setDistricts] = useState([]);
  const [constituency, setConstituency] = useState([]);
  const [userDistrict, setUserDistrict] = useState([]);
  const [userConstituency, setUserConstituency] = useState([]);

  useEffect(() => {
    getBtech();
    getDistricts();
  }, []);

  const handleMouseEnterFlag = () => {
    setIsOpenFlag(true);
  };

  const handleMouseLeaveFlag = () => {
    setIsOpenFlag(false);
  };
  // var headerURL = ""

  useEffect(() => {
    setToggleUser((prevState) => !prevState);
    loaddata();
  }, []);

  const openRegisterModal = () => {
    setPostModal(true);
    // onClose()
  };
  const closemodal = () => {
    setPostModal(false);
    setModalShow(true);
  };

  useEffect(() => {
    getLogo();
    headerTypes();
    getTrainingRegistrationData();

    // console.log("local storage data", JSON.parse(localStorage.getItem('userdata')));

    // localStorage.removeItem('userdata')
    var tntId = JSON.parse(localStorage.getItem("tID"));

    const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`));

    if (userdata == null) {
      setUser("");
    } else if (userdata.accessToken) {
      setUser(userdata.user.name);
      setUserProfile(userdata.user.image);
      setUserMobile(userdata.user.mobileno);
      setSelectedState(userdata.user.stateid);
    }
  }, [toggleUser]);

  const getLogo = async () => {
    const action = "INTRO";
    const reqparam = {
      pageno: "-1",
      query: { status: "Active" },
    };

    const ResponseData = await GetApi(reqparam, action);
    // console.log("intro response", ResponseData);
    setLogo(ResponseData?.data);

    const reqparam2 = {
      pageno: "-1",
      query: {},
    };

    const ResponseData1 = await GetApi(reqparam2, "TENANT");
    // console.log("response tenant data", ResponseData1.data[0]);
    // alert()
    setTenantData(ResponseData1.data[0]);
    var tntId = JSON.parse(localStorage.getItem("tID"));
    localStorage.setItem(
      `tenantdata${tntId}`,
      JSON.stringify(ResponseData1?.data[0])
    );

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }

    // adding favcon
    link.href = ResponseData?.data[0]?.smallicon;
    // console.log(ResponseData1, "check tenant name");
    //adding document title
    document.title = ResponseData1?.data[0]?.name;
  };

  const headerTypes = async () => {
    let reqparams = "";
    var tntId = JSON.parse(localStorage.getItem("tID"));
    setTenantId(tntId);
    const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`));
    setUserData(userdata);
    if (userdata?.user?.subapplicationid && userdata != null) {
      reqparams = {
        pageno: "-1",
        query: {
          status: "Active",
          area: {
            $elemMatch: { value: userdata?.user?.subapplicationid },
          },
        },
      };
    } else {
      reqparams = {
        pageno: "-1",
        query: { status: "Active" },
      };
    }

    // console.log("header reqparams", reqparams);

    const dataResponse = await PostApi(reqparams, "VPTTYPES");

    // console.log("VPT headers", dataResponse.data);
    setHeaderTabs(dataResponse?.data);
  };

  const openModal = () => {
    setModalOpen((prevState) => !prevState);
    // setModalShow((prevState) => !prevState);
  };

  const logIn = () => {
    setToggleUser((prevState) => !prevState);
  };
  const logOut = async (e) => {
    // await removeToken()
    e.preventDefault();
    setShowModal(true);

    // openModal()
    // setToggleUser(prevState=>!prevState)
  };

  //logout confirmation

  const exitmodal = () => {
    setShowModal(false);
  };

  const logoutConfirmed = async () => {
    // console.log("userMobile",userMobile);

    const reqparams = {
      mobileno: userMobile,
      // mobileno:"9391645909"
    };
    const clearsessionrespone = await PostApi(reqparams, "LOGOUT");
    // console.log("clearsessionrespone", clearsessionrespone);
    var tntId = JSON.parse(localStorage.getItem("tID"));

    localStorage.removeItem(`userdata${tntId}`);

    logIn();

    setShowModal(false);

    window.location.href = "/";
  };

  const getTrainingRegistrationData = async () => {
    const reqparams = {
      pageno: "-1",
      query: { status: "Active" },
    };
    const courseslistResp = await PostApi(reqparams, "TRAININGCOURSES");

    // console.log("TRAININGCOURSES datta", courseslistResp.data);

    let count = 0;
    const rowdat = [];
    await courseslistResp.data.reduce(async (promise, res) => {
      await promise;
      const opts = {
        key: res.id,
        value: res.name,
      };
      rowdat.push(opts);
      if (count == courseslistResp.data.length - 1) {
        setCourses(rowdat);
      }
      count++;
    }, Promise.resolve());
  };

  const notifymodal = async () => {
    setNotificationmodal(true);
  };
  const closeNotifyModal = async () => {
    setNotificationmodal(false);
  };

  const clsDeleteModal = async () => {
    setDeleteModal(false);
  };
  const deleteAccount = async () => {
    setDeleteModal(true);
  };
  const deactivateConfirmed = async () => {
    const query = {
      userid: "",
      tenantid: "",
    };
    const deleteResp = await PostApi(query, "DELETEACCOUNT");
    // console.log("deleteResp",deleteResp);
    if (deleteResp.message == "SUCCESS") {
      var tntId = JSON.parse(localStorage.getItem("tID"));

      localStorage.removeItem(`userdata${tntId}`);
      logIn();
      setDeleteModal(false);
      // history.push(`${"/"}`)
      window.location.href = "/";
    } else {
      toast.error("Failed to delete account", {
        position: "center",
        autoClose: 5000,
      });
    }
  };
  const AcademicValidate = async (e) => {
    var tntId = JSON.parse(localStorage.getItem("tID"));
    const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`));
    if (userdata == null) {
      setModalUp(true);
      e.preventDefault();

      toast.info("login to check course details", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const closeModal = async () => {
    setModalUp(false);
  };
  const signIn = async () => {};

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        // size="lg"
        // aria-labelledby="contained-modal-title-vcenter"
        // centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{ marginLeft: "auto" }}
          >
            Enroll for offline/online class
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <TabStyles>
            <div className="main-wrapper faq-page">
              <section className="faq-area" style={{ paddingTop: "2%" }}>
                <Container>
                  <Row>
                    <Col md="12">
                      <Tab.Container defaultActiveKey="student">
                        <Nav className="justify-content-center">
                          <Nav.Item>
                            <Nav.Link eventKey="student">Student </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="fresher">Fresher</Nav.Link>
                          </Nav.Item>
                          {/* <Nav.Item><Nav.Link eventKey="employee">Employee</Nav.Link></Nav.Item> */}
                        </Nav>
                        <Tab.Content>
                          <Tab.Pane eventKey="student">
                            <Row>
                              <Student dataprop={courses} />
                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="fresher">
                            <Row>
                              <Fresher dataprop={courses} />
                            </Row>
                          </Tab.Pane>

                          <Tab.Pane eventKey="employee">
                            <Row>
                              <Employee dataprop={courses} />
                            </Row>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </Col>
                  </Row>
                </Container>
              </section>
            </div>
          </TabStyles>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
        {/* <ToastContainer /> */}
      </Modal>
    );
  }

  const loginValidate = async () => {
    var tntId = JSON.parse(localStorage.getItem("tID"));
    const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`));
    if (userdata == null) {
      setModalOpen((prevState) => !prevState);

      toast.info("login required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const loaddata = async () => {
    var tntId = JSON.parse(localStorage.getItem("tID"));

    const sessiondetails = localStorage.getItem(`userdata${tntId}`);
    if (sessiondetails != null) {
      const userdata = JSON.parse(sessiondetails);

      const reqparam = {
        pageno: "-1",
        ptype: "GETUSER",
        query: { _id: userdata.user.id },
      };
      const resDat = await PostApi(reqparam, "USERPROJECTS");
      if (resDat?.data?.couponpurchase == "No") {
        setCouponPurchase(true);
      }
    }
  };

  const [userdata, setUserdata] = useState();
  const getBtech = async () => {
    var edutypeId = null;
    var tntId = JSON.parse(localStorage.getItem("tID"));
    const sessiondetails = localStorage.getItem(`userdata${tntId}`);
    const localUserdata = JSON.parse(sessiondetails);
    setUserdata(localUserdata?.user?.roles[0].name);

    if (sessiondetails != null) {
      const localUserdata = JSON.parse(sessiondetails);
      // console.log(localUserdata.user.studentedutype, "check About us")
      if (localUserdata.user.studentedutype == "btech") {
        edutypeId = "1";
      } else if (localUserdata.user.studentedutype == "degree") {
        edutypeId = "2";
      } else if (localUserdata.user.studentedutype == "pg") {
        edutypeId = "3";
      }
    }
    settenantData(tntId);
    let reqparams = "";

    if (localUserdata?.user.subapplicationid && localUserdata != null) {
      reqparams = {
        pageno: "-1",
        query: {
          status: "Active",
          area: {
            $elemMatch: { value: localUserdata?.user?.subapplicationid },
          },
        },
      };
    } else {
      reqparams = {
        pageno: "-1",
        query: { status: "Active" },
      };
    }

    const dataResponse = await PostApi(reqparams, "EDUCATION");
    setEduData(dataResponse?.data);
    if (edutypeId == null) {
      if (sessiondetails != null) {
        const filterEdu = dataResponse?.data.filter(
          (ele) => ele.educationcode == "1"
        );
        setEduData(filterEdu);
        if (localUserdata.user.roles[0].name == "DEMO_USER") {
          setEduData(dataResponse?.data);
        }
      } else {
        setEduData(dataResponse?.data);
      }
    } else {
      const filterEdu = dataResponse?.data.filter(
        (ele) => ele.educationcode == edutypeId
      );

      setEduData(filterEdu);
    }

    const reqparams2 = {
      pageno: "-1",
      query: { status: "Active" },
    };
    const dataResponse1 = await PostApi(reqparams2, "EDUCATIONTYPES");
    // console.log("about us Response", dataResponse1);

    setEduTypes(dataResponse1?.data);

    const disreqparam = {
      pageno: "-1",
      query: { status: "Active", _id: localUserdata?.user?.districtid },
    };
    const DistrictsResponseMessage = await GetApi(disreqparam, "DISTRICTS");
    setUserDistrict(DistrictsResponseMessage?.data[0]);
    const constituencyreqparam = {
      pageno: "-1",
      query: { status: "Active", _id: localUserdata?.user?.subapplicationid },
    };
    const ConstituencyResponseMessage = await GetApi(
      constituencyreqparam,
      "CONSTITUENCY"
    );
    setUserConstituency(ConstituencyResponseMessage?.data[0]);
  };

  const jobrolepage = async (data) => {
    history.push({
      pathname: "/jobroles",
      state: data,
    });
  };

  const getDistricts = async () => {
    const reqparam2 = {
      pageno: "-1",
      query: { status: "Active" },
    };
    const StateResponseMessage = await PostApi(reqparam2, "STATES");
    // console.log("StateResponseMessage", StateResponseMessage);
    const reqparam = {
      pageno: "-1",
      query: { status: "Active", stateid: StateResponseMessage?.data[0].id },
    };
    const DistrictsResponseMessage = await GetApi(reqparam, "DISTRICTS");
    // console.log("DistrictsResponseMessage", DistrictsResponseMessage);
    setDistricts(DistrictsResponseMessage?.data);

    const reqparam3 = {
      pageno: "-1",
      query: { status: "Active" },
    };

    const ResponseMessage1 = await GetApi(reqparam3, "CONSTITUENCY");
    setConstituency(ResponseMessage1?.data);
  };




  return (
    <Styles>
      {/* Logo Area 2 */}
      <section className="logo-area2">
        <Row
          className="align-items-center nav-bg p-2 m-auto"
          style={{
            backgroundImage: `url(${navimg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Col md="4" style={{ zIndex: "99999", display: "flex" }}>
            <Link to={"/"}>
              <img
                className="logo"
                src={`${logo[0] && logo[0]?.largeicon}`}
                alt=""
              />
            </Link>
           {!user && <div className="dropdown-wrapper">

              <div className="menu-button dropdown-toggle">
                MP Constituency
              </div>

              <div className="dropdown">
                {
                  districts?.map((data) => {
                    return <div className="dropdown-item has-submenu">
                      {data.name}
                      <span className="arrow">
                        <i className="fa fa-chevron-right"></i>
                      </span>
                      <div className="submenu">
                        {constituency
                          .filter((c) => c.districtid === data.id)
                          .map((c) => (
                            <div key={c.id} className="submenu-item" onClick={loginValidate}>
                              {c.name}
                            </div>
                          ))}
                      </div>
                    </div>

                  })
                }

              </div>
            </div>}

            {user && (
              <div className="dropdown-wrapper">
                <div className="menu-button dropdown-toggle">
                  {userDistrict?.name}
                </div>

                <div className="dropdown">
                  <div className="dropdown-item has-submenu">
                    {userConstituency?.name}
                    {/* <span className="arrow">
                    <i className="fa fa-chevron-right"></i>
                  </span> */}
                  </div>
                </div>
              </div>
            )}
          </Col>
          <Col md="8">
            <div className="menu-box d-flex justify-content-end">
              <ul
                className="nav menu-nav"
                style={{ display: "flex", alignItems: "center" }}
              >
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to={"/"}
                    data-toggle="dropdown"
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item dropdown jobs" style={{ zIndex: 999 }}>
                  <Dropdown>
                    <Dropdown.Toggle variant="" className="allprograms">
                      JOB ROLES
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {eduData?.map((data, ind) => {
                        const filteredEduTypes = eduTypes?.filter(
                          (sub) => sub.educationid === data.id
                        );
                        let index = false;
                        if (user) {
                          if (userdata != "DEMO_USER") {
                            index = ind > 0;
                          } else {
                            index = ind > 2;
                          }
                        } else {
                          index = ind > 2;
                        }
                        return index ? (
                          <Dropdown
                            as="li"
                            className="dropdown-submenu position-relative"
                            key={ind}
                          >
                            <Dropdown.Toggle
                              as="a"
                              className="dropdown-item fs-5 w-100 d-flex justify-content-between align-items-center"
                            >
                              {data.name}
                            </Dropdown.Toggle>

                            {filteredEduTypes.length > 0 && (
                              <Dropdown.Menu className="position-absolute start-100 top-0">
                                {filteredEduTypes.map((sub, subIndex) => (
                                  <Dropdown.Item
                                    key={subIndex}
                                    onClick={() => jobrolepage(sub)}
                                  >
                                    {sub.name}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            )}
                          </Dropdown>
                        ) : null;
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                {couponPurchase &&
                  headerTabs?.map((tab, ind) => {
                    return (
                      <>
                        {tab.name === "Coding Practice" && (
                          <li className="nav-item dropdown">
                            <Link
                              className="nav-link dropdown-toggle"
                              to={"/codeeditor"}
                              data-toggle="dropdown"
                            >
                              Coding Practice
                            </Link>
                          </li>
                        )}
                      </>
                    );
                  })}
                {/* 
                                {tenantdata.tenantid != "80b42fdf" && <li className="nav-item dropdown" >
                                    <Link className="nav-link dropdown-toggle" to={'/codeeditor'} data-toggle="dropdown" >Coding Practice</Link>
                                </li>} */}

                {headerTabs?.length > 0 && (
                  <li
                    className="nav-item dropdown "
                    onMouseEnter={handleMouseEnterFlag}
                    onMouseLeave={handleMouseLeaveFlag}
                    style={{ height: "40px" }}
                  >
                    <Dropdown show={isOpenFlag}>
                      <Dropdown.Toggle variant="" className="allprograms">
                        ALL PROGRAMS
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {headerTabs?.map((tab, ind) => {
                          let url = "";
                          if (tab.name === "Students") {
                            url = "/collegescholars";
                          }
                          if (tab.name === "Academic Subjects") {
                            // AcademicValidate()
                            // url = '/subjects'
                          }

                          if (tab.name === "Technical Courses") {
                            url = "/course-list";
                          }
                          if (tab.name === "Employability skills") {
                            url = "/crt-program";
                          }
                          if (tab.name === "Professionals") {
                            url = "/course-list";
                          }
                          if (tab.name === "Freshers") {
                            url = "/course-list";
                          }
                          return (
                            <>
                              {tab.name === "Academic Subjects" && (
                                <Dropdown.Item key={ind}>
                                  {(tenantId != "2b7b1a31" ||
                                    userData?.user?.year == "4") && (
                                    <Link
                                      className="dropdown-item fs-5"
                                      onClick={AcademicValidate}
                                      to={{
                                        pathname: "/subjects",
                                        state: { data: selectedState },
                                      }}
                                      data-toggle="dropdown"
                                      key={ind}
                                    >
                                      {tab.name}{" "}
                                    </Link>
                                  )}
                                </Dropdown.Item>
                              )}

                              {(tab.name === "Technical Courses" ||
                                tab.name === "Professionals" ||
                                tab.name === "Freshers") && (
                                <Dropdown.Item key={ind}>
                                  <Link
                                    className="dropdown-item fs-5"
                                    onClick={AcademicValidate}
                                    to={{ pathname: "/course-list" }}
                                    data-toggle="dropdown"
                                    key={ind}
                                  >
                                    {tab.name}{" "}
                                  </Link>
                                </Dropdown.Item>
                              )}
                              {tab.name === "Employability skills" && (
                                <Dropdown.Item key={ind}>
                                  {(tenantId != "2b7b1a31" ||
                                    userData?.user?.year == "4") && (
                                    <Link
                                      className="dropdown-item fs-5"
                                      onClick={AcademicValidate}
                                      to={{ pathname: "/crt-program" }}
                                      data-toggle="dropdown"
                                      key={ind}
                                    >
                                      {tab.name}{" "}
                                    </Link>
                                  )}
                                </Dropdown.Item>
                              )}
                              {tab.name === "Students" && (
                                <Dropdown.Item key={ind}>
                                  <Link
                                    className="dropdown-item fs-5"
                                    onClick={AcademicValidate}
                                    to={{ pathname: "/collegescholars" }}
                                    data-toggle="dropdown"
                                    key={ind}
                                  >
                                    {tab.name}{" "}
                                  </Link>
                                </Dropdown.Item>
                              )}
                            </>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                )}
                {user && tenantdata.tenantid != "80b42fdf" && (
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle"
                      to={"/MyCourses"}
                      data-toggle="dropdown"
                    >
                      My Courses
                    </Link>
                  </li>
                )}

                {tenantdata?.isofflineenrollment && (
                  <li className="nav-item dropdown">
                    <button
                      type="button"
                      className="btn  trainingreg tooltip1"
                      onClick={() =>
                        user ? setOfflineModalShow(true) : loginValidate()
                      }
                    >
                      Training Registration
                      <span className="tooltiptext1">
                        Registration for free online training
                      </span>{" "}
                    </button>
                  </li>
                )}

                {!user && (
                  <li className="nav-item dropdown ms-3" onClick={openModal}>
                    {/* <Link className="nav-link dropdown-toggle" to={process.env.PUBLIC_URL +"/login"} >Signin </Link> */}

                    <button className="btn Signin"> Signin </button>
                  </li>
                )}

                {modalOpen && (
                  <LoginModal
                    onClose={openModal}
                    show={modalShow}
                    Hide={modalOpen}
                    login={logIn}
                  />
                )}

                {!user && (
                  <li className="nav-item dropdown">
                    <button className="btn Login" onClick={openRegisterModal}>
                      {" "}
                      Sign Up{" "}
                    </button>
                  </li>
                )}
                {user && (
                  <li>
                    <Dropdown className="mx-4">
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        className="user rounded-pill"
                      >
                        {/* {user} */}
                        {/* {console.log("user profile value",userProfile)} */}
                        <Image
                          className=" d-inline profileimg pl-0 ml-0"
                          src={
                            userProfile
                              ? `data:image/jpeg;base64,${userProfile}`
                              : "https://tse3.mm.bing.net/th?id=OIP._lZHLa4KljgIGbchN7qRTgHaHa&pid=Api&P=0&h=180"
                          }
                          roundedCircle
                        />
                        <span
                          className="d-inline"
                          style={{
                            marginLeft: "10%",
                            fontSize: "16px",
                            paddingRight: "5",
                          }}
                        >
                          {user}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {/* <Dropdown.Item href="#/action-1">{user}</Dropdown.Item> */}
                        {tenantdata.tenantid != "80b42fdf" && (
                          <Link to={`${"/about"}`}>
                            {" "}
                            <Dropdown.Item
                              href="#/action-2"
                              className="profile profile2"
                            >
                              My Profile
                            </Dropdown.Item>{" "}
                          </Link>
                        )}

                        <Link to={`${"/changepassword"}`}>
                          {" "}
                          <Dropdown.Item
                            href="#/action-2"
                            className="profile profile2"
                          >
                            Change Password
                          </Dropdown.Item>{" "}
                        </Link>
                        <Dropdown.Item
                          className="profile"
                          href="#"
                          onClick={deleteAccount}
                        >
                          Deactivate account
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="profile"
                          href="#"
                          onClick={logOut}
                        >
                          Log out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                )}

                {user && (
                  <div class="col">
                    {" "}
                    <li onClick={notifymodal} className="notify">
                      <i className="fa-solid fa-bell"></i>
                    </li>
                  </div>
                )}
              </ul>
              {/* <div className="search-box">
                                        <Search />
                                    </div> */}

              {/* <div className="apply-btn">
                                        <Link to={process.env.PUBLIC_URL + "/registration"}><i className="las la-clipboard-list"></i>Apply Now</Link>
                                    </div> */}
            </div>
          </Col>
        </Row>
      </section>

      {/* Sticky Menu */}
      {/* <StickyMenu /> */}

      {/* Mobile Menu */}
      <MobileMenu />

      <Modal size="l" show={postModal}>
        <div className="" role="document">
          <div className="">
            <form>
              <div class="modal-header py-4 border-0">
                {/* <button className='btn btn-warning mx-3 py-2 px-3 fw-bold'>Freshers</button>
                                <button className='btn btn-outline-secondary py-2 px-3 fw-bold'>Experience</button> */}
                <button
                  onClick={closemodal}
                  data-dismiss="modal"
                  type="button"
                  class="btn-close bg-white opacity-100 border border-2 border-warning rounded-circle close-btn"
                  onclick="closeModal()"
                ></button>
              </div>

              <div className="modal-body">
                <Register closemodal={closemodal} loginmodal={openModal} />
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* offlineEnroll modal */}

      <MyVerticallyCenteredModal
        show={offlineModalShow}
        onHide={() => setOfflineModalShow(false)}
      />

      {/* logout confirmation model */}

      <Modal size="l" show={showModal}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  onClick={exitmodal}
                  data-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body text-center">
                <h5>Are you sure you want to logout ?</h5>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={logoutConfirmed}
                >
                  ok
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={exitmodal}
                  data-dismiss="modal"
                >
                  cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal size="lg" show={notificationmodal}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeNotifyModal}
                  data-dismiss="modal"
                ></button>
              </div>
              <div>
                <Notifications />
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal size="l" show={deleteModal}>
        <div className="" role="document">
          <div className="">
            <form>
              <div className="modal-header">
                <button
                  type="button"
                  className="btn-close"
                  onClick={clsDeleteModal}
                  data-dismiss="modal"
                ></button>
              </div>
              <div className="modal-body text-center">
                <h5>
                  Are you sure you want to deactivate your account , Once you
                  deactivate, you cannot login again ?
                </h5>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={deactivateConfirmed}
                >
                  ok
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={clsDeleteModal}
                  data-dismiss="modal"
                >
                  cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {modalUp && <LoginModal onClose={closeModal} login={signIn}></LoginModal>}
    </Styles>
  );
}
